import React from 'react';
import {Dropdown, DropdownChangeEvent} from 'primereact/dropdown';
import {useTranslation} from "react-i18next";
import AdminFieldLabel from './AdminFieldLabel';

interface DropdownOption {
  value: string;
  label: string;
}

interface AdminInputDropdownProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: DropdownOption[];
  placeholder?: string;
  required?: boolean;
  name: string;
  id: string;
  className?: string;
  error?: string;
}

const AdminInputDropdown: React.FC<AdminInputDropdownProps> = ({
  label,
  value,
  onChange,
  options,
                                                                 placeholder,
  required = false,
  name,
  id,
                                                                 className = '',
                                                                 error
}) => {
  const {t} = useTranslation();
  const defaultPlaceholder = t('admin.common.dropdowns.selectOption');

  const handleDropdownChange = (e: DropdownChangeEvent) => {
    const syntheticEvent = {
      target: {
        name: name,
        value: e.value || ''
      }
    } as React.ChangeEvent<HTMLSelectElement>;
    onChange(syntheticEvent);
  };

  return (
    <div className={className}>
      <AdminFieldLabel htmlFor={id} label={label} required={required}/>
      <Dropdown
        id={id}
        name={name}
        value={value || null}
        options={options}
        filter
        onChange={handleDropdownChange}
        optionLabel="label"
        optionValue="value"
        placeholder={placeholder || defaultPlaceholder}
        className={`w-full px-2 py-1 border rounded-sm focus:outline-none focus:ring-1 focus:ring-gray-800 focus:border-transparent transition duration-300 ${error ? 'border-red-500' : 'border-gray-300'}`}
        showClear={!required}
        virtualScrollerOptions={{itemSize: 45, autoSize: true, orientation: 'vertical'}}
      />
      {error && <small className="block text-red-500 text-xs mt-1">{error}</small>}
    </div>
  );
};

export default AdminInputDropdown;
